"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayoutData = void 0;
const class_transformer_1 = require("class-transformer");
const AssignationPayout_1 = require("../models/AssignationPayout");
const DriverDebt_1 = require("../models/DriverDebt");
const AssignationDataForPayout_1 = require("./AssignationDataForPayout");
const PayoutForPayoutsPage_1 = require("./PayoutForPayoutsPage");
class PayoutData {
    _id;
    payout;
    otherPayouts;
    assignations;
    assignationPayouts;
    otherDebtsWithNonExistingPayout;
    debts;
}
exports.PayoutData = PayoutData;
__decorate([
    (0, class_transformer_1.Type)(() => PayoutForPayoutsPage_1.PayoutForPayoutsPage),
    __metadata("design:type", PayoutForPayoutsPage_1.PayoutForPayoutsPage)
], PayoutData.prototype, "payout", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => PayoutData),
    __metadata("design:type", Array)
], PayoutData.prototype, "otherPayouts", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => AssignationDataForPayout_1.AssignationDataForPayout),
    __metadata("design:type", Array)
], PayoutData.prototype, "assignations", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => AssignationPayout_1.AssignationPayout),
    __metadata("design:type", Array)
], PayoutData.prototype, "assignationPayouts", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => DriverDebt_1.DriverDebt),
    __metadata("design:type", Array)
], PayoutData.prototype, "otherDebtsWithNonExistingPayout", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => DriverDebt_1.DriverDebt),
    __metadata("design:type", Array)
], PayoutData.prototype, "debts", void 0);
//# sourceMappingURL=PayoutData.js.map